import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const favoriteScheduledReportsAdapter = getAdapter({ idFieldName: 'id' });

const favoriteScheduledReportsSlice = createSlice({
  name: 'favoriteScheduledReports',
  initialState: favoriteScheduledReportsAdapter.getInitialState(),
  reducers: {
    setFavoriteScheduledReports: (state, { payload: { favoriteScheduledReports } }) => {
      favoriteScheduledReportsAdapter.setAll(state, favoriteScheduledReports);
    },
  },
});

const selectors = favoriteScheduledReportsAdapter.getSelectors(({ favoriteScheduledReports }) => favoriteScheduledReports);

export const getFavoriteScheduledReports = (state) => selectors.selectAll(state);

export const {
  setFavoriteScheduledReports,
} = favoriteScheduledReportsSlice.actions;

export default favoriteScheduledReportsSlice.reducer;